import z from '@/lib/zod';
import { SKIP, TAKE } from '@/lib/constants/pagination';

export const commonSearchSchema = z.object({
  search: z.string().nullish(),
  skip: z.number().nullish().default(SKIP),
  take: z.number().nullish().default(TAKE),
  sort: z.any().nullish(),
  show: z.string().nullish(),
  tab: z.string().nullish(),
});

export type CommonSearchSchemaInput = z.infer<typeof commonSearchSchema>;
